(function userQueryControllerDefinition() {
    'use strict';

    angular.module('UserQuery')
        .controller('UserQueryFindController', [
            '$scope', '$state', '$translate', 'authExtend', 'errorsExtend', 'alerts', 'userQueryService', 'storageService',
            function userQueryController($scope, $state, $translate, authExtend, errors, alerts, userQueryService, storageService) {

                $scope.find =
                {
                        name: ''
                };

                $scope.data = {
                    currentPage: 1,
                    totalItems: 0,
                    itemsPerPage: 15,
                    from: 0
                };

                $scope.Load = function ()
                {

                    $translate(['PaginationNext', 'PaginationPrev', 'PaginationLastFem', 'PaginationFirstFem'])
                        .then(function (translated) {
                            $scope.paginatorTranslations = {
                                nextText: translated.PaginationNext,
                                previousText: translated.PaginationPrev,
                                lastText: translated.PaginationLastFem,
                                firstText: translated.PaginationFirstFem
                            };
                        });

                    $scope.findAction();

                };

                $scope.findAction = function () {

                    return userQueryService.get($scope.find.name, null,$scope.data.currentPage, $scope.data.itemsPerPage).then(function (result) {
                        $scope.items = result.value;
                        $scope.data.totalItems = result.totalCount;
                        $scope.data.from = result.from;
                    }, function (error) {
                        errors.showError(error);
                    });
                };

                $scope.remove = function (userQuery) {
                    return $translate(['Warning', 'UserQueryRemoveMessage', 'Yes', 'No']).then(function (translated) {
                        return alerts.confirm(translated.Warning, translated.UserQueryRemoveMessage, translated.Yes, translated.No).then(function getOk(result) {
                            if (!result) {
                                return result;
                            }

                            return userQueryService.delete(userQuery).then(function getOk(result) {
                                $scope.findAction();
                            }, function (error) {
                                errors.showError(error);
                            });
                        });
                    });
                };

                $scope.apply = function (userQuery) {
                    
                    storageService.setUserQuery(userQuery);

                    switch (userQuery.type) {
                        case 'Documents':
                            storageService.setDocumentFilter(angular.fromJson(userQuery.filters));
                            $state.go('document-advanced-find');
                            break;
                        case 'DocumentContainers':
                            storageService.setContainerFilter(angular.fromJson(userQuery.filters));
                            $state.go('document-container-advanced-find');
                            break;
                    }
                };

                $scope.Load();
            }
        ]);
})();